<template>
  <div>
    <Pos_choose_product/>
  </div>
</template>

<script>
import Pos_choose_product from "@/components/adminArin/pos_system/warehouse/manage_product/Pos_choose_product";
export default {
  name: "PosChooseProduct",
  components: {
    Pos_choose_product
  }
}
</script>

<style scoped>

</style>
